/**
 * @description module entry
 * @author wangfupeng
 */
 

import withMarkdown from './plugin'

const module = {
  editorPlugin: withMarkdown,
}

export default module
